import { render, staticRenderFns } from "./Broadcast_Like_Comment.vue?vue&type=template&id=a4774328&scoped=true&"
import script from "./Broadcast_Like_Comment.vue?vue&type=script&lang=js&"
export * from "./Broadcast_Like_Comment.vue?vue&type=script&lang=js&"
import style0 from "./Broadcast_Like_Comment.vue?vue&type=style&index=0&id=a4774328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4774328",
  null
  
)

export default component.exports